import { FactoryDOMConfig } from '@gebruederheitz/clicktrigger2';
import { $, $$ } from '@gebruederheitz/wp-frontend-utils';

export function clicktrigger() {
    if (document?.gh?.clicktrigger) {
        return new FactoryDOMConfig();
    }
}

export function bandRows() {

    if ($$()('.ghwp-bands').length) {
        window.addEventListener('hashchange', function() {
            showBand(location.hash);
        });

        if (location.hash) {
            showBand(location.hash);
        }
    }
}

function showBand(hash) {
    const id = '#band-info' + hash.substring(5);
    const bandInfo = $()(id);
    if (!bandInfo) {
        return;
    }
    const row = bandInfo.parentNode;
    if (!row.classList.contains('visible')) {
        row.classList.add('visible');
    }
}



